import styled from "styled-components";

export const PreRegisterStyled = styled.div`
  .logo_img {
    margin: auto;
    margin-bottom: 20px;
    max-width: 148px;
    width: 100%;
    height: auto;
  }
  .title {
    margin-bottom: 17px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
  }
  .btn_first_regis {
    position: relative;
    margin: auto;
    margin-bottom: 23px;
    border-radius: 53px;
    padding: 22px 64px;
    max-width: 340px;
    text-align: center;
    background: ${({ theme }) => theme.COLORS.PURPLE_1};
    cursor: pointer;
    .btn_first_label {
      color: ${({ theme }) => theme.COLORS.WHITE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S22};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
    .btn_first_icon {
      position: absolute;
      top: 50%;
      right: 18px;
      display: flex;
      transform: translateY(-50%);
    }
  }
  .or_label {
    margin-bottom: 17px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S20};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
  }
  .sub_title {
    margin-bottom: 7px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S20};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    white-space: pre-wrap;
  }
  .section {
    margin-bottom: 42px;
  }

  .title_s2 {
    margin-bottom: 14px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S18};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
  }
  .sub_title_s2 {
    margin-bottom: 23px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    white-space: pre-wrap;
  }
`;
